import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kartotekaSaldoText',
})
export class KartotekaSaldoTextPipe implements PipeTransform {
  transform(saldo: number): string {
    return saldo < 0 ? 'text-danger' : 'text-secondary-500';
  }
}
